import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { useUrlShortenerContext } from 'pages/settings/pages/urlShortener/context/UrlShortenerContext'
import { getUrlShortenerActions } from 'pages/settings/pages/urlShortener/ui/actions/getUrlShortenerActions'
import styles from './styles.module.scss'
import { columns } from './columns'

export const UrlShortenerListTable = observer(() => {
  const store = useUrlShortenerContext()
  const { tableStore, initialLoading, items } = store
  const getColumns = useMemo(() => columns(), [])

  const rows = useMemo(() => {
    return items.map((item) => {
      item.setActionsProps({
        actions: getUrlShortenerActions(item, store),
      })

      item.setAriaLabel('UrlShortener')

      return item
    })
  }, [items])

  return (
    <section className={styles.table}>
      <Table
        ariaLabel={'UrlShortenerTable'}
        store={tableStore}
        columns={getColumns}
        rows={rows}
        loading={initialLoading}
        hidePagination
      />
    </section>
  )
})
